import create from "zustand";
import { ILP, ResponseData } from "../pages/dashboard/WalletLayout";

interface ILiquidityPartners {
  showLp: boolean;
  Lp: ILP;
  lpWallet: ResponseData;
  setWallet: (lpWallet: ResponseData) => void;
  currentRamp: string;
  selectedLpId: string;
  activeLp: boolean;
  showWallet: boolean;
  showWalletModal: boolean;
  showStableWallet: boolean;
  setShowLp: (shouldShow: boolean) => void;
  setLp: (data: ILP) => void;
  setSelectedLpId: (id: string) => void;
  setCurrentRamp: (ramp: string) => void;
  setActiveLp: (isActive: boolean) => void;
  setShowWallet: (isActive: boolean) => void;
  setShowWalletModal: (isActive: boolean) => void;
  setShowStableWalletModal: (isActive: boolean) => void;
}

export const useLpStore = create<ILiquidityPartners>((set) => ({
  showLp: false,
  currentRamp: "off-ramp",
  lpWallet: {
    blockchain: "",
    createdAt: "",
    deletedAt: null,
    id: "",
    ramp: "off-ramp",
    selected: false,
    updatedAt: "",
    walletAddress: "",
    walletType: "",
  },
  Lp: {
    createdAt: "",
    deletedAt: "",
    id: "",
    name: "",
    updatedAt: "",
  },
  selectedLpId: "",
  activeLp: false,
  showWallet: false,
  showStableWallet: false,
  showWalletModal: false,

  //setters
  setShowWalletModal: (showWalletModal: boolean) =>
    set((state) => ({ showWalletModal: showWalletModal })),
  setShowStableWalletModal: (showStableWallet: boolean) =>
    set((state) => ({ showStableWallet: showStableWallet })),

  setShowWallet: (showWallet: boolean) =>
    set((state) => ({ showWallet: showWallet })),
  setShowLp: (shouldShow: boolean) => set((state) => ({ showLp: shouldShow })),
  setLp: (data: ILP) => set((state) => ({ Lp: data })),
  setWallet: (data: ResponseData) => set((state) => ({ lpWallet: data })),
  setSelectedLpId: (id: string) => set((state) => ({ selectedLpId: id })),
  setCurrentRamp: (ramp: string) => set((state) => ({ currentRamp: ramp })),
  setActiveLp: (isActive: boolean) => set((state) => ({ activeLp: isActive })),
}));
